<div class="navigation">
    <three-dot-navigation [menuItems]="navigationMenuItems()"></three-dot-navigation>
</div>
<div class="address">
    <div class="header-wrapper">
        <div class="header">
            {{ titleText() }}
        </div>
    </div>
    <div class="subinfo">
        @if(keyInfo()?.ownershipEstateSubTypeDisplayText || keyInfo()?.ownershipEstateTypeDisplayText) {
        <div class="address-info">{{ keyInfo()?.ownershipEstateSubTypeDisplayText ?? keyInfo()?.ownershipEstateTypeDisplayText }}</div>
        } 
        
        @if(identityText()) {
        <div class="address-info">
            <div class="identity">
                {{ identityText() }}
                <ev-icon-tooltip [title]="'Unik identifikator'" [iconType]="'info'">
                    <div class="tooltip-content">
                        {{ identityTooltipText }}
                    </div>
                </ev-icon-tooltip>
            </div>
        </div>
        }

        @if(organization()) {
        <div class="address-info">{{ organization() }}</div>
        }

        @if(cadastre() != null && showCadastre()) {
        <div class="address-info">
            <div class="cadastre" cdkOverlayOrigin #cadastreOrigin="cdkOverlayOrigin" (click)="cadastreDialogVisible = !cadastreDialogVisible">
                <div class="cadastre-info">{{ cadastre() }}</div>
                <div class="information-icon"></div>

                <ev-cdk-tooltip
                    [origin]="cadastreOrigin"
                    [visible]="cadastreDialogVisible"
                    [title]="'MATRIKKEL'"
                    [width]="'320px'"
                    (close)="cadastreDialogVisible = false"
                >
                    <div class="tooltip-content">
                        {{ cadastreTooltip() }}
                    </div>
                </ev-cdk-tooltip>
            </div>
        </div>
        }
        
        @for (area of keyInfo().areaUnitInfo?.areaUnitsForHeader; track $index; let i = $index) {
        <div class="header-wrapper">
            <a class="area-info" [class.hasBorder]="area.hasGeographicBorder" href="{{ areaInfoLink(area) }}">
                <div class="area-title">{{ area.title }}:</div>
                <div class="area-icon" [class.hasBorder]="area.hasGeographicBorder" [attr.data-cy]="'data-cy=infopage-header-area-icon-' + i"></div>
                <div class="area">{{ area.name | capitalize : false : ["-", "/"] }}</div>
            </a>
        </div>
        }
    </div>
</div>
